import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(() => ({
  headerStyling: {
    width: "75vw",
    padding: "16px",
    margin: "0 auto"
  }
}));
